import multicall from "../multicall"
import { ProductCart } from "./cartProductTypes"
import { constants } from "@src/constants"
import { Abi } from "viem"
import ProductsModule from "@src/lib/artifacts/contracts/ProductsModule.sol/ProductsModule"
import { zeroAddress } from "viem"

export async function updateExternalPrices({
  cart,
  dynamicItems,
  chainId,
  buyer,
  setBasePrice = false
}: {
  cart: ProductCart[]
  dynamicItems: ProductCart[]
  chainId: number
  buyer?: string
  setBasePrice?: boolean
}) {
  const ids: [number, number][] = []
  const args: any[] = []
  const currencies: any[] = []
  const updatedCart = [...cart]

  dynamicItems.forEach((el) => {
    const { slicerId, productId, quantity, currency } = el
    ids.push([slicerId, productId])
    args.push([
      slicerId,
      productId,
      currency,
      quantity,
      buyer || "0x0000000000000000000000000000000000000001", // use address 1 to prevent eventual reverts
      ""
    ])
    currencies.push(currency)
  })

  const dynamicPrices = await getExternalPrices(args, ids, currencies, chainId)

  Object.entries(dynamicPrices).forEach(([slicerId, productVal]) => {
    Object.entries(productVal as any).forEach(
      ([productId, currencyVal]: [any, any]) => {
        const currency = dynamicItems.find(
          (el: { slicerId: number; productId: number }) =>
            el.slicerId == Number(slicerId) && el.productId == Number(productId)
        )?.currency
        const price =
          currencyVal[currency!][
            currency === zeroAddress ? "ethPrice" : "currencyPrice"
          ]
        const index = updatedCart.findIndex(
          (el) =>
            el.slicerId == Number(slicerId) && el.productId == Number(productId)
        )

        updatedCart[index][setBasePrice ? "basePrice" : "price"] =
          "0x" + BigInt(price).toString(16)
      }
    )
  })

  return updatedCart
}

export const getExternalPrices = async (
  args: string[][],
  ids: [number, number][],
  currencies: string[],
  chainId: number
) => {
  const returnedPrices = {}
  const data = await multicall(
    constants[chainId].addresses.ProductsModule,
    ProductsModule.abi as Abi,
    "productPrice",
    args
  )

  ids.forEach(([slicerId, productId], i) => {
    if (data[i]?.status == "success") {
      const { eth: ethPrice, currency: currencyPrice } = data[i].result as any

      if (!returnedPrices[slicerId]) returnedPrices[slicerId] = {}
      returnedPrices[slicerId][productId] = {
        [currencies[i]]: {
          ethPrice,
          currencyPrice
        }
      }
    }
  })

  return returnedPrices
}

// TODO: FIX cart button not disappearing in products with invalid dynamic price (not here)
